export const NAME_LABEL = "Name";
export const SURNAME_LABEL = "Surname";
export const PASSWORD_LABEL = "Password";
export const CONFIRM_PASSWORD_LABEL = "Confirm Password";
export const EMAIL_LABEL = "Email";
export const NEW_PASSWORD_LABEL = "New Password";
export const CONFIRM_NEW_PASSWORD_LABEL = "Confirm New Password";
